export default "__VITE_ASSET__diNlHS8K__"